// extracted by mini-css-extract-plugin
export default {"container":"FieldsRenderer_container__CHZEQ","wrapper":"FieldsRenderer_wrapper__p4bIB"};